The opaque cursor to the position opening.

This can be used as a subsequent pagination argument.
